// Scroll reveal for the home page card grids.
// Every card is observed on its own, NOT the grid: a card only starts its
// animation when it is actually scrolled into view, so a card further down the
// page is still hidden by the time you reach it. Cards that do enter together
// are released one after the other (the case rows), or all at once when the
// stagger is 0 (the "Conoce más" and "Revive la experiencia" rows).
// The hidden starting state lives in CSS behind the `js-reveal` class, which
// default.hbs adds inline in <head> to avoid a flash; if none of the conditions
// below are met we remove that class again and every card is simply visible.
(function () {
    var root = document.documentElement;
    var grids = [
        {selector: '.cases-grid', item: '.case-card', stagger: 250},
        {selector: '.know-more-grid', item: '.page-card', stagger: 0},
        // the "Revive la experiencia" feed: one row of three on desktop, so the
        // same all-at-once release as the "Conoce más" row
        {selector: '.post-feed', item: '.post-card', stagger: 0}
    ];

    function bail() {
        root.classList.remove('js-reveal');
    }

    if (!root.classList.contains('js-reveal')) return;

    if (!('IntersectionObserver' in window)) {
        bail();
        return;
    }

    if (window.matchMedia('(prefers-reduced-motion: reduce)').matches) {
        bail();
        return;
    }

    grids.forEach(function (config) {
        var grid = document.querySelector(config.selector);
        if (!grid) return;

        var items = Array.prototype.slice.call(grid.querySelectorAll(config.item));
        if (!items.length) return;

        // cards waiting to be released, in document order
        var queue = [];
        var timer = null;

        function release() {
            if (!queue.length) return;
            if (timer === null) timer = window.setTimeout(onGapElapsed, config.stagger);
        }

        function onGapElapsed() {
            timer = null;
            queue.shift().classList.add('is-revealed');
            release();
        }

        function onVisible(entries) {
            entries.forEach(function (entry) {
                if (!entry.isIntersecting) return;
                observer.unobserve(entry.target);
                queue.push(entry.target);
            });

            if (config.stagger) {
                // one card at a time, DOM order
                queue.sort(function (a, b) {
                    return items.indexOf(a) - items.indexOf(b);
                });
                release();
            } else {
                // same row: they have to land together
                queue.forEach(function (item) { item.classList.add('is-revealed'); });
                queue = [];
            }
        }

        var observer = new IntersectionObserver(onVisible, {
            // trigger a little before the card is fully on screen, and only
            // once a decent slice of it is visible
            rootMargin: '0px 0px -10% 0px',
            threshold: 0.12
        });

        items.forEach(function (item) {
            observer.observe(item);
        });
    });
})();
